import ErrorPage from "../../components/ErrorPage"

type ServerErrorProps = {
    onRetry?: () => void
}

export default function ServerError({ onRetry }: ServerErrorProps) {
    return (
        <ErrorPage
            code="500"
            accentColor="#29cc6a"
            illustration="server-error"
            stickers={[
                { label: "техсбой ⚡", color: "#29cc6a", rotate: -2 },
                { label: "проектор 🎥", color: "#349be6", rotate: 2 },
                { label: "попкорн ждёт 🍿", color: "#e4206b", rotate: -1 },
            ]}
            title={
                <>
                    Проектор <span style={{ color: "#29cc6a" }}>не включился</span>
                </>
            }
            description="Что-то пошло не так на нашей стороне — как сбой в аппаратной. Попробуйте обновить страницу, мы уже чиним."
            marquee={["технический сбой", "перезагрузите страницу", "скоро всё заработает", "спасибо за терпение"]}
            primaryAction={{
                label: "Обновить страницу",
                onClick: onRetry ?? (() => window.location.reload()),
            }}
            secondaryAction={{ label: "На главную", to: "/" }}
        />
    )
}
